import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FormData } from '@/shared/model/form.model';
import KeywordsCMSModel, { Keywords } from '@/visa-application/models/KeywordsCMSModel';
import _ from 'lodash';

@Component
export default class FormSelection extends Vue {
  @Prop() public forms: FormData[];
  @Prop() public selectForms: Function;
  private keywords: Partial<Keywords> = {};

  public selectedForms: FormData[] = this.forms;

  public confirm(): void {
    if (this.selectedForms.length > 0) {
      this.selectForms(this.selectedForms);
    }
  }

  @Watch('$store.getters.keywords', { immediate: true })
  public onKeywordsChanged(keywords: Keywords): void {
    this.keywords = keywords;
  }
}
